export interface UseQueryParamResponse {
    [key: string]: string;
}

function useQueryParam(url: string | Location): UseQueryParamResponse {
    const params: UseQueryParamResponse = {};
    const parsedUrl = new URL(url as string);
    const urlSearchParams = new URLSearchParams(parsedUrl.search);

    urlSearchParams.forEach((value: string, key: string) => (params[key] = value));

    return params;
}

export { useQueryParam };
